module.exports = __webpack_public_path__ + "static/media/Kopparhälsan_uses_Curoflow_telemedicine_platform.2ae237f2.webp";